export const gallery = [
  { url: '../wellcome-2.png' },
  { url: '../wellcome-1.png' },
  { url: '../wellcome-3.png' },
]
